import type { CSSProperties } from "react";

import { m } from "@/paraglide/messages.js";
import { BOOKING_COLORS, type BookingColor } from "@complete-athlete/enums";

/**
 * Service colors are names ("blue", "green"). Each has a token of its own, apart from the brand's
 * decorative ones: their whole job is telling services apart, so they must stay different hues
 * whatever the theme is.
 */
const COLOR_VALUE = Object.fromEntries(
  BOOKING_COLORS.map((color) => [color, color === "gray" ? "var(--muted-foreground)" : `var(--service-${color})`]),
) as Record<string, string>;

export const serviceColorValue = (color: string) => COLOR_VALUE[color] ?? "var(--primary)";

/** Sets `--service` on an element so its classes can tint from it. */
export const serviceColorStyle = (color: string) => ({ "--service": serviceColorValue(color) }) as CSSProperties;

const COLOR_LABEL: Record<BookingColor, () => string> = {
  red: () => m.booking_color_red(),
  orange: () => m.booking_color_orange(),
  yellow: () => m.booking_color_yellow(),
  lime: () => m.booking_color_lime(),
  green: () => m.booking_color_green(),
  teal: () => m.booking_color_teal(),
  cyan: () => m.booking_color_cyan(),
  blue: () => m.booking_color_blue(),
  indigo: () => m.booking_color_indigo(),
  purple: () => m.booking_color_purple(),
  pink: () => m.booking_color_pink(),
  brown: () => m.booking_color_brown(),
  gray: () => m.booking_color_gray(),
};

/** The colors a service or event can pick, in picker order, with their names. */
export const BOOKING_COLOR_OPTIONS = BOOKING_COLORS.map((value) => ({ value, label: COLOR_LABEL[value] }));
